import { invert } from 'lodash';
/* 
  Helper code to organize task types across the project
*/

// Any additions or changes here also need to be changed in the server side task types enum
const messageTemplateTypes = {
  accountability: 1,
  admin: 2,
  churn: 3,
  disengaged: 4,
  generalHabits: 5,
  mindset: 6,
  missedWorkout: 7,
  nutrition: 8,
  onboarding: 9,
  rocking: 10,
  workout: 11,
  resources: 12,
};

// const messageTemplateTypesArray = [
//   messageTemplateTypes.disengaged,
//   messageTemplateTypes.missedWorkout,
// ];
const messageTemplateTypesArray = Object.values(messageTemplateTypes);

const stringForMessageTemplateTypes = invert(messageTemplateTypes);

export {
  messageTemplateTypes,
  stringForMessageTemplateTypes,
  messageTemplateTypesArray,
};
